import React from 'react';

import PropTypes from 'prop-types';
import Box from '@tds/core-box';
import Heading from '@tds/core-heading';

import {
  Thead,
  Td,
  Tr,
  Th
} from '../orderDetailsSection/ratePlans/components/css';
import getFormattedPricing from '../orderDetailsSection/utils';

const Services = ({ serviceData, serviceName }) => {
  if (!serviceData.length) return null;

  return (
    <table>
      <Thead>
        <Tr>
          <Th width="50%">{serviceName}</Th>
          <Th width="10%">Rate Plan Unit</Th>
          <Th width="10%">MTM Units</Th>
          <Th width="10%">Total Unit</Th>
          <Th width="10%">Unit Price</Th>
          <Th width="10%">Total</Th>
        </Tr>
      </Thead>
      <tbody>
        {serviceData.map(data => {
          const {
            name,
            includedQuantity,
            additionalQuantity,
            unitPrice
          } = data;
          return (
            <Tr>
              <Td style={{ background: '#f7f7f7', fontWeight: '700' }}>
                {name}
              </Td>
              <Td>{includedQuantity}</Td>
              <Td>{additionalQuantity}</Td>
              <Td>{includedQuantity + additionalQuantity}</Td>
              <Td>{getFormattedPricing(unitPrice)}</Td>
              <Td>{getFormattedPricing(unitPrice * additionalQuantity)}</Td>
            </Tr>
          );
        })}
      </tbody>
    </table>
  );
};

Services.propTypes = {
  serviceName: PropTypes.string.isRequired,
  serviceData: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      device: PropTypes.string,
      term: PropTypes.string,
      quantity: PropTypes.number,
      unitPrice: PropTypes.number,
      fiftyPercentInUS: PropTypes.bool
    })
  ).isRequired
};

const SummaryHardware = ({ orderData, total }) => {
  const { hardwareList, accessoryList } = orderData;

  return (
    <>
      {total === 0 && <h4>No hardware Selected</h4>}
      {total > 0 && (
        <Box between={3}>
          <Heading level="h4">Hardware</Heading>
          <Box>
            <Services serviceData={hardwareList} serviceName="Hardware" />
            <Services serviceData={accessoryList} serviceName="Accessories" />
            <div
              style={{
                background: '#f4f4f4',
                border: '1px solid #e3e3e3',
                display: 'flex',
                justifyContent: 'space-between',
                padding: '1rem'
              }}
            >
              <p style={{ marginLeft: '16rem', fontWeight: '600' }}>Total</p>
              <p style={{ marginRight: '0.65rem', fontWeight: '600' }}>
                {getFormattedPricing(total)}
              </p>
            </div>
          </Box>
        </Box>
      )}
    </>
  );
};

SummaryHardware.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.any).isRequired,
  total: PropTypes.number.isRequired
};

export default SummaryHardware;
